export const billings = [
  {
    id: 'bill_001',
    organizationId: 'org_3la_labs',
    contractId: 'ctr_001',
    contractNumber: 'CTR-2026-001',
    clientId: 'cli_xpto',
    clientName: 'XPTO Tecnologia',
    period: '09/2026',
    description: 'Suporte mensal + Licenças — setembro/2026',
    services: [
      { productName: 'Suporte mensal', quantity: 1, unitPrice: 1500, total: 1500 },
      { productName: 'Licença 3LA Manager', quantity: 5, unitPrice: 299, total: 1495 },
    ],
    amount: 2995,
    dueDate: '10/09/2026',
    billedAt: '01/09/2026',
    invoiceIssuedAt: '01/09/2026',
    boletoIssuedAt: '01/09/2026',
    invoiceId: 'nf_bill_001',
    invoiceNumber: '000241',
    receivableId: 'ar_bill_001',
    boletoId: 'bol_001',
    boletoNumber: '23791.12345 60000.000001 00000.000120 1 98670000299500',
    bankAccountId: 'bank_bb',
    bankAccountName: 'Banco do Brasil',
    status: 'Concluído',
  },
  {
    id: 'bill_002',
    organizationId: 'org_3la_labs',
    contractId: 'ctr_002',
    contractNumber: 'CTR-2026-002',
    clientId: 'cli_emsoft',
    clientName: 'Emsoft',
    period: '09/2026',
    description: 'Suporte mensal — setembro/2026',
    services: [
      { productName: 'Suporte mensal', quantity: 1, unitPrice: 1800, total: 1800 },
    ],
    amount: 1800,
    dueDate: '10/09/2026',
    billedAt: '01/09/2026',
    invoiceIssuedAt: '02/09/2026',
    boletoIssuedAt: null,
    invoiceId: 'nf_bill_002',
    invoiceNumber: '000242',
    receivableId: 'ar_bill_002',
    boletoId: null,
    boletoNumber: null,
    bankAccountId: 'bank_bb',
    bankAccountName: 'Banco do Brasil',
    status: 'NF emitida',
  },
  {
    id: 'bill_003',
    organizationId: 'org_3la_labs',
    contractId: 'ctr_004',
    contractNumber: 'CTR-2026-003',
    clientId: 'cli_horizonte',
    clientName: 'Horizonte',
    period: '09/2026',
    description: 'Horas + suporte — setembro/2026',
    services: [
      { productName: 'Desenvolvimento sob demanda', quantity: 40, unitPrice: 180, total: 7200 },
      { productName: 'Suporte mensal', quantity: 1, unitPrice: 1200, total: 1200 },
    ],
    amount: 8400,
    dueDate: '15/09/2026',
    billedAt: '03/09/2026',
    invoiceIssuedAt: null,
    boletoIssuedAt: null,
    invoiceId: null,
    invoiceNumber: null,
    receivableId: 'ar_bill_003',
    boletoId: null,
    boletoNumber: null,
    bankAccountId: 'bank_bb',
    bankAccountName: 'Banco do Brasil',
    status: 'Faturado',
  },
  {
    id: 'bill_004',
    organizationId: 'org_3la_labs',
    contractId: 'ctr_001',
    contractNumber: 'CTR-2026-001',
    clientId: 'cli_xpto',
    clientName: 'XPTO Tecnologia',
    period: '10/2026',
    description: 'Suporte mensal + Licenças — outubro/2026',
    services: [
      { productName: 'Suporte mensal', quantity: 1, unitPrice: 1500, total: 1500 },
      { productName: 'Licença 3LA Manager', quantity: 5, unitPrice: 299, total: 1495 },
    ],
    amount: 2995,
    dueDate: '10/10/2026',
    billedAt: null,
    invoiceIssuedAt: null,
    boletoIssuedAt: null,
    invoiceId: null,
    invoiceNumber: null,
    receivableId: null,
    boletoId: null,
    boletoNumber: null,
    bankAccountId: 'bank_bb',
    bankAccountName: 'Banco do Brasil',
    status: 'A faturar',
  },
  {
    id: 'bill_005',
    organizationId: 'org_3la_labs',
    contractId: 'ctr_002',
    contractNumber: 'CTR-2026-002',
    clientId: 'cli_emsoft',
    clientName: 'Emsoft',
    period: '10/2026',
    description: 'Suporte mensal — outubro/2026',
    services: [
      { productName: 'Suporte mensal', quantity: 1, unitPrice: 1800, total: 1800 },
    ],
    amount: 1800,
    dueDate: '10/10/2026',
    billedAt: null,
    invoiceIssuedAt: null,
    boletoIssuedAt: null,
    invoiceId: null,
    invoiceNumber: null,
    receivableId: null,
    boletoId: null,
    boletoNumber: null,
    bankAccountId: 'bank_bb',
    bankAccountName: 'Banco do Brasil',
    status: 'A faturar',
  },
];
